function ContactUs() {
  return (
    <section id="contact" className="contact-section">
      <div className="contact-inner">
        <span className="section-eyebrow">Contact Us</span>
        <h2>Let's talk about your reporting stack</h2>
        <p>
          We're currently onboarding early users and partners who manage
          multiple QuickBooks entities and are tired of manual consolidation.
          Reach out and we'll help you get set up.
        </p>

        <div className="contact-methods">
          <a className="contact-method" href="mailto:hello@qapfinancials.com">
            <span className="contact-method-label">Email</span>
            <span className="contact-method-value">hello@qapfinancials.com</span>
          </a>
          <div className="contact-method">
            <span className="contact-method-label">Response time</span>
            <span className="contact-method-value">Within 1 business day</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
